export default "__VITE_ASSET__Cta711fH__"